import type {SVGProps} from 'react'
const BrandPickupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 100 100"
    width="1em"
    height="1em"
    {...props}
  >
    <g
      stroke="#2d2e2c"
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path
        strokeWidth={1.5}
        d="M49.496 17.75c10.373 0 18.75 8.202 18.75 18.281 0 2.831-.66 5.51-1.838 7.902L49.705 69.318a.25.25 0 0 1-.418 0L32.583 43.933a17.8 17.8 0 0 1-1.837-7.902c0-10.08 8.378-18.281 18.75-18.281Z"
      />
      <circle cx={49.496} cy={35} r={7} />
      <path strokeWidth={1.5} d="M24 82h51" />
    </g>
  </svg>
)
export {BrandPickupIcon}
